module.exports = __webpack_public_path__ + "static/media/icon-security.0c2ef0a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-security.svg
// module id = 1223
// module chunks = 19